import { useMemo } from 'react';

import Calendar, { CalendarClassNames } from 'components/calendar';
import { ServicesMonthPicker } from 'components';

import { useStyles } from './style';

interface Props {
  date: Date;
  handleChangeDate: (date: Date | null) => void;
  className?: string;
}

const ServicesCalendarPicker: React.FC<Props> = ({
  date,
  handleChangeDate,
  className,
}) => {
  const classes = useStyles();

  const calendarCls: CalendarClassNames = useMemo(
    () => ({
      root: classes.calendarRoot,
      weekDaysBlock: classes.day,
      weekDay: classes.weekDay,
      weekDaysWrapper: classes.weekDaysWrapper,
      weekRow: classes.weekRow,
      daysWrapper: classes.daysWrapper,
      day: classes.day,
    }),
    [classes]
  );

  return (
    <div className={className}>
      <div className={classes.monthPickerWrapper}>
        <ServicesMonthPicker date={date} onChange={handleChangeDate} />
      </div>
      <Calendar
        currentDate={date}
        activeDate={date}
        handleChangeDate={handleChangeDate}
        cls={calendarCls}
      />
    </div>
  );
};

export default ServicesCalendarPicker;
